export default function headerScript() {
  (function () {
    const isFixedScrollPositionActive = 200;
    const showButtonElements = document.querySelectorAll('.navbar-mobile__hamburger');
    const closeButtonElements = document.querySelectorAll('.navbar-mobile__close-button');
    const navigationBarElement = document.querySelector('.fahlo-navigation-bar');
    const navElement = document.querySelector('nav.navigation');

    function getCurrentScroll() {
      return document.documentElement.scrollTop;
    }

    function onScroll() {
      const scrollPosition = getCurrentScroll();

      if (scrollPosition >= isFixedScrollPositionActive) {
        navElement.classList.add('--is-fixed');
      } else {
        navElement.classList.remove('--is-fixed');
      }
    }

    function toggleNavigationSidedar() {
      const navListElements = document.querySelectorAll('#navbar-list');
      navigationBarElement.classList.toggle('--is-open');
      for (let i = 0; i < navListElements.length; i++) {
        const navListElement = navListElements[i];
        navListElement.classList.toggle('--is-visible');
      }
    }

    function hideEmptyHeaderDropdowns() {
      const headerDropdowns = document.querySelectorAll('.navbar-dropdown');
      for (let i = 0; i < headerDropdowns.length; i++) {
        const dropdown = headerDropdowns[i];
        const menu = dropdown.querySelector('.navbar-menu');
        if (menu && menu.children && menu.children.length === 0) {
          dropdown.setAttribute('hidden', true);
        }
      }
    }

    function init() {
      window.addEventListener('scroll', (element) => onScroll(element), { passive: true });
      for (let i = 0; i < showButtonElements.length; i++) {
        const showButtonElement = showButtonElements[i];
        showButtonElement.addEventListener('click', toggleNavigationSidedar);
      }
      for (let j = 0; j < closeButtonElements.length; j++) {
        const closeButtonElement = closeButtonElements[j];
        closeButtonElement.addEventListener('click', toggleNavigationSidedar);
      }
      hideEmptyHeaderDropdowns();
    }

    onScroll();
    init();
  })();
}
